import React from 'react';
import {Text, TextMessage} from 'components/tt-forms/common';
import moment from 'moment';

class ThongTinYeuCauKiemTraDeXuat extends React.Component {

  constructor(props, context){
    super(props, context);
    this.state = {
      data: this.props.data
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({data: nextProps.data})
  }

  getDonViPhoiHop() {
    let dataReturn = [];
    this.state.data.donViPhoiHops.map((state, i) => {
      dataReturn.push(state.ten);
    });
    return dataReturn.join(', ');
  }

  render() {
    let Data = this.state.data;
    let lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    return (
      <section className="wrap-block mt15">
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <h2 className='title-14 mb15'>Thông tin yêu cầu kiểm tra đề xuất</h2>
        <div className='row pl10 pr10'>
          <Text className='col-25 mb10' value={Data && Data.donViDuocGiaoTTXM ? Data.donViDuocGiaoTTXM.ten : ''} label={'Đơn vị được giao '+lb1+':'}/>
          <Text className='col-25 mb10' red={true} value={Data && Data.ngayBaoCaoKQ ? moment(Data.ngayBaoCaoKQ).format("DD/MM/YYYY") : ''} label='Thời gian báo cáo kết quả:'/>
          <Text className='col-25 mb10' value={Data && Data.ngayGuiKQ ? moment(Data.ngayGuiKQ).format("DD/MM/YYYY") : ''} label='Thời gian đơn vị gửi kết quả:'/>
          {/* <Text className='col-25 mb10' value={Data && Data.donViPhoiHops ? this.getDonViPhoiHop() : ''} label='Đơn vị phối hợp:'/> */}
          <TextMessage className='col-100' value={Data && Data.yKienXuLy ? Data.yKienXuLy : ''} label='Ý kiến xử lý:'/>
        </div>
      </section>
    );
  }
}

ThongTinYeuCauKiemTraDeXuat.defaultProps = {
  data: []
}

export default ThongTinYeuCauKiemTraDeXuat;


// WEBPACK FOOTER //
// ./src/components/modules/reception/ThongTinYeuCauKiemTraDeXuat.jsx